import MultiSelect from 'modules/core/components/MultiSelect'
import i18n from 'modules/core/lib/i18n'

import { MaterializedItemsFormValues } from 'modules/processes/hooks/useWizardItemForm'
import { AssigneeTypeSubOptions } from 'modules/processes/lib/assigneeTypeSubOptions'

interface Props {
  teamIds: string[]
  readonly: boolean
  formKey: keyof MaterializedItemsFormValues
  strategy: keyof typeof AssigneeTypeSubOptions
  changeValue: (
    key: keyof MaterializedItemsFormValues,
    value: number | string | undefined | number[]
  ) => void
}

const TeamMultiSelectOption = ({ teamIds, formKey, strategy, readonly, changeValue }: Props) => {
  return (
    <MultiSelect
      label=""
      options={AssigneeTypeSubOptions[strategy](teamIds)}
      readonly={!!readonly}
      onSubmit={(updatedOptions) => {
        const filteredData = updatedOptions ? updatedOptions.filter((value) => value.selected) : []
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        changeValue(formKey, filteredData.map((value) => value.value) as number[])
      }}
      getLabel={(count) => {
        if (count === 0) return `--${i18n.t('common.choose')}--`

        return i18n.tp('common.option_selected', {
          count,
        })
      }}
      getSubmitLabel={(count) =>
        i18n.tp('common.option_selected', {
          count,
        })
      }
    />
  )
}

export default TeamMultiSelectOption
